export const dayClassNames =
  "flex h-[3.2rem] w-[3.2rem] items-center justify-center";

export const disabledDayClassNames =
  "disabled:text-neutral-400 disabled:cursor-not-allowed";

export const todayClassNames = "border-b-[0.2rem] border-b-neutral-850";

export const dayWrapperClassNames = "flex gap-small text-ui justify-center";

export const selectedDayClassNames = "rounded bg-blue-560 text-white";
